import React from "react";
import { useLocation, Link } from "react-router-dom";
import { gradeClassFor } from "../utils/honeyGrade";
import { localizedName, localizedDescription } from "../utils/localizeProduct";
import { useLanguage } from "../i18n/LanguageContext";

const ProductCard = ({ product, onAddToOrder }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const { language, t } = useLanguage();

  const name = localizedName(product, language);

  return (
    <div className="product-card">
      {product.imageUrl ? (
        <img src={product.imageUrl} alt={name} />
      ) : (
        <div className="jar-swatch">
          <div className="jar-lid" />
          <div className="jar-neck" />
          <div className={`jar-body ${gradeClassFor(product)}`} />
        </div>
      )}

      <h3>{name}</h3>
      <p className="product-note">{localizedDescription(product, language)}</p>

      <div className="product-card-footer">
        <span className="price">${Number(product.price).toFixed(2)}</span>
        {!isAdmin ? (
          <button
            className="mini-btn"
            onClick={() => onAddToOrder && onAddToOrder(product, 1)}
          >
            {t("product.add")}
          </button>
        ) : (
          <Link to={`/admin/products/edit/${product.id}`} className="mini-btn">
            {t("product.edit")}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
